import { Component } from '@angular/core';

@Component({
  selector: 'app-rp-why-us-section',
  templateUrl: './why-us-section.component.html',
  styleUrls: ['./why-us-section.component.scss'],
})
export class WhyUsSectionComponent {
  reasons = [
    {
      icon: 'svg:zap',
      titleKey: 'recruiterProgram.whyUs.items.fasterHiring.title',
    },
    {
      icon: 'svg:riyal',
      titleKey: 'recruiterProgram.whyUs.items.lowerCost.title',
    },
    {
      icon: 'svg:ai-user',
      titleKey: 'recruiterProgram.whyUs.items.higherQuality.title',
    },
    {
      icon: 'svg:ai-brain',
      titleKey: 'recruiterProgram.whyUs.items.dataDriven.title',
    },
    {
      icon: 'svg:zap',
      titleKey: 'recruiterProgram.whyUs.items.simpleUx.title',
    },
  ];
}
